export const refundableTicketEnLocale = {
  'refundable-ticket.title': 'Refundable ticket',
  'refundable-ticket.selection-required': 'Selection required',
  'refundable-ticket.refund-description-part1': 'Get a',
  'refundable-ticket.refund-amount': '100% refund',
  'refundable-ticket.refund-description-part2': 'of this purchase for only',
  'refundable-ticket.refund-description-part3':
    'in case you cannot attend for many reasons of our',
  'refundable-ticket.terms-and-conditions': 'Terms and Conditions',
  'refundable-ticket.refund-description-part4':
    'which you accept by choosing the',
  'refundable-ticket.refundable-option': 'REFUNDABLE',
  'refundable-ticket.covered-reasons-title':
    'Protect your tickets if you cannot attend your event for covered reasons such as:',
  'refundable-ticket.reason-illness': 'Accident and illness',
  'refundable-ticket.reason-emergency': 'Family or home emergency',
  'refundable-ticket.reason-documents': 'Lost or stolen documents',
  'refundable-ticket.reason-weather': 'Severe weather',
  'refundable-ticket.reason-transport': 'Transport disruptions',
  'refundable-ticket.reason-others': 'And many more!',
  'refundable-ticket.option-yes-label':
    'Yes, I want to make my purchase 100% refundable',
  'refundable-ticket.option-yes-selected':
    'Great choice! Your ticket purchase is protected.',
  'refundable-ticket.option-yes-description':
    'Have peace of mind in any eventuality.',
  'refundable-ticket.option-no-label':
    'No, I will not protect my ticket purchase',
  'refundable-ticket.option-no-selected':
    'Your ticket purchase is NOT protected.',
  'refundable-ticket.option-no-description': `I understand that this decision may put the {value} I spent on tickets at risk.`,
  'refundable-ticket.highly-recommended': 'Highly recommended',
  'refundable-ticket.error-protect-active':
    'Refundable ticktes active, but an error occurred while loading it.',
} as const;

export const refundableTicketEsLocale = {
  'refundable-ticket.title': 'Ticket reembolsable',
  'refundable-ticket.selection-required': 'Selección requerida',
  'refundable-ticket.refund-description-part1': 'Obtén un',
  'refundable-ticket.refund-amount': '100% reembolso',
  'refundable-ticket.refund-description-part2': 'de esta compra por solo',
  'refundable-ticket.refund-description-part3':
    'en caso de que no puedas asistir por muchas razones de nuestro',
  'refundable-ticket.terms-and-conditions': 'Términos y condiciones',
  'refundable-ticket.refund-description-part4': 'que aceptas al elegir el',
  'refundable-ticket.refundable-option': 'REEMBOLSABLE',
  'refundable-ticket.covered-reasons-title':
    'Protege tus entradas si no puedes asistir a tu evento por razones cubiertas como:',
  'refundable-ticket.reason-illness': 'Accidente y enfermedad',
  'refundable-ticket.reason-emergency': 'Emergencia familiar o en el hogar',
  'refundable-ticket.reason-documents': 'Documentos perdidos o robados',
  'refundable-ticket.reason-weather': 'Clima severo',
  'refundable-ticket.reason-transport': 'Interrupciones en el transporte',
  'refundable-ticket.reason-others': '¡Y muchos más!',
  'refundable-ticket.option-yes-label':
    'Sí, quiero hacer mi compra 100% reembolsable',
  'refundable-ticket.option-yes-selected':
    '¡Gran elección! Tu compra de entradas está protegida.',
  'refundable-ticket.option-yes-description':
    'Ten tranquilidad ante cualquier eventualidad.',
  'refundable-ticket.option-no-label': 'No, no protegeré mi compra de entradas',
  'refundable-ticket.option-no-selected':
    'Tu compra de entradas NO está protegida.',
  'refundable-ticket.option-no-description':
    'Entiendo que esta decisión puede poner en riesgo los {value} que gasté en entradas.',
  'refundable-ticket.highly-recommended': 'Altamente recomendado',
  'refundable-ticket.error-protect-active':
    'Ticket reembolsable activo, pero ocurrió un error al cargarlo.',
} as const;
